inputs-search-keyword
  div(class="form-group { error: opts.errors }")
    input(if="{!opts.disabled}" class="form-control form-control-lg { opts.klass }" name="{ opts.name }" placeholder="{ opts.placeholder }" type="text" value="{ opts.value }" onInput="{this.onInput}" onChange="{this.onChange}")
    input(if="{ opts.disabled}" class="form-control form-control-lg { opts.klass }" name="{ opts.name }" placeholder="{ opts.placeholder }" type="text" value="{ opts.value }" onInput="{this.onInput}" onChange="{this.onChange}" disabled="disabled")
  script(type="typescript").
    this.mixin('inputs.textfield');
